import { IPromotionState } from '../../../../reducers/v2';
import { isPromotionForbidden, isPromotionToggleChecked, isPromotionToggleDisabled } from './utils';
import { EUnavailableReason } from '../../../../types/reducers/publishTerms';
import { IAddFormPublishTermsResponse } from '../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { mapPromotionServices } from './mapPromotionServices';
import { mapAuctionBet } from './mapAuctionBet';
import { mapDurations } from './mapDurations';

export const mapPromotion = (response: IAddFormPublishTermsResponse): Omit<IPromotionState, 'isChangedByUser'> => {
  return {
    auctionBet: mapAuctionBet(response.auction),
    duration: mapDurations(response),
    services: mapPromotionServices(response),
    toggle: {
      checked: isPromotionToggleChecked(response),
      disabled: isPromotionToggleDisabled(response),
    },
    moderation: {
      isAllowed: !isPromotionForbidden(response.terms),
      unavailableReasonType: EUnavailableReason.deniedBySanctions,
    },
    competitors: [],
  };
};
